// import { configureStore } from "@reduxjs/toolkit";
// import { usersApi } from "./api";


// const store = configureStore({
//     reducer: {
//         [usersApi.reducerPath]: usersApi.reducer,

//     },
//     middleware: (getDefaultMiddleware) =>
//         getDefaultMiddleware()
//             .concat(usersApi.middleware)

// });

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import { apiService } from "../services/apiService";

export const store = configureStore({
  reducer: {
    [apiService.reducerPath]: apiService.reducer
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiService.middleware)
});